<template>
  <div class="dashboard-cnt">
    <header>
      <span class="icon-Btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="16" viewBox="0 0 21 16">
          <path
            fill="#F2564D"
            d="M1.625.487h7.313c.807 0 1.462.655 1.462 1.463s-.655 1.463-1.463 1.463H1.625C.817 3.413.163 2.758.163 1.95S.817.488 1.625.488zm10.238 11.7h7.312c.808 0 1.462.655 1.462 1.463s-.654 1.463-1.462 1.463h-7.313c-.807 0-1.462-.655-1.462-1.463s.655-1.463 1.463-1.463zM1.625 6.338h17.55c.808 0 1.462.655 1.462 1.463s-.654 1.462-1.462 1.462H1.625C.817 9.262.163 8.608.163 7.8c0-.808.654-1.462 1.462-1.462z"
          />
        </svg>
      </span>
      <h1>{{$t('partTime')}}</h1>
      <router-link tag="span" class="user-icon" :to="{ path: '/profile'}" v-if="userInfo">
        <img :src="userInfo.profileImageUrl" v-if="userInfo.profileImageUrl" />
        <img src="../assets/images/dummy.png" v-else />
      </router-link>
    </header>
    <ul class="lot-tab">
      <li class="ctgtab" :class="{'select-tab' : !isActive}">
        <label for="test1">{{$t('allTasks')}}</label>
        <input
          type="radio"
          id="test1"
          name="radio-group"
          value="allTask"
          v-model="taskStatus"
          @click="changeStatus('allTask')"
        />
      </li>
      <li class="ctgtab" :class="{'select-tab' : isActive}">
        <label for="test2">{{$t('myTasks')}}</label>
        <input
          type="radio"
          id="test2"
          name="radio-group"
          value="myTask"
          v-model="taskStatus"
          @click="changeStatus('myTask')"
        />
      </li>
    </ul>

    <section class="mid-cnt">
      <AllTaskList v-if="taskStatus === 'allTask'" />
      <MyTaskList v-if="taskStatus === 'myTask'" />
    </section>
    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import "../assets/css/dashboard.css";
// import "../assets/scss/dashboard.scss";
import AllTaskList from "../components/AllTaskList";
import MyTaskList from "../components/MyTaskList";
import ApiCaller from "../utils/apicaller";
import constant from "../utils/constant";
import { SessionHelper, X_AUTH_ID } from "../utils/session";
import { mapGetters } from "vuex";
import types from "../store/types";
import CustomToaster from "../components/Common/CustomToaster";

export default {
  name: "Home",
  components: {
    AllTaskList,
    MyTaskList,
    CustomToaster
  },
  computed: {
    ...mapGetters(["userInfo", "updateUserInfo"])
  },
  data() {
    return {
      isActive: false,
      taskStatus: "allTask",
      loading: false,
      toasterData: {},
      isValidDetail: false
    };
  },
  methods: {
    changeStatus(task_status) {
      this.$cookie.set("taskStatus", task_status);
      if (this.$cookie.get("taskStatus") == "alltask") {
        this.isActive = !this.isActive;
      } else {
        this.isActive = !this.isActive;
      }
    },
    getUserInfo() {
      this.loading = true;
      ApiCaller(
        constant.USERINFO_URL,
        "userinfo/" + SessionHelper.getCookie(X_AUTH_ID),
        "get"
      )
        .then(data => {
          this.loading = false;
          this.$store.commit(types.GET_USER_INFO, data.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserDetailObject() {
      this.loading = true;
      ApiCaller(constant.BASE_API_URL, "user/userdetails/", "get")
        .then(data => {
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  mounted() {
    if(this.$cookie.get("taskStatus")){
      this.taskStatus = this.$cookie.get("taskStatus");
     if (this.$cookie.get("taskStatus") == "allTask") {
        this.isActive = !this.isActive;
      } else {
        this.isActive = !this.isActive;
      }
      if (this.taskStatus == null) {
        this.taskStatus = "allTask";
      }
      if (this.taskStatus == "allTask") {
        this.isActive = !this.isActive;
      }
    }    
    if (!this.userInfo.id) {
      this.getUserInfo();
    }
    this.getUserDetailObject();
  }
};
</script>

